<div class="app-habitation-v2 tooltips-container">
  <span
    id="infobulle-{{ id }}"
    (click)="afficheInfoBulle()"
    class="btn-tooltip mobile-only"
    [class.btn-tooltip-style-less]="isInsideText"
  >
    <img
      *ngIf="showQuestionMark"
      src="{{ 'assets/images/info.svg' | cheminAbsoluStatique }}"
      [alt]="altText"
      width="18"
      height="18"
      class="icon"
    />
  </span>

  <div class="desktop-only">
    <app-tooltip-desktop
      [id]="id"
      [showQuestionMark]="showQuestionMark"
      [isInsideText]="isInsideText"
      [ariaLabel]="ariaLabel"
      [titre]="titre"
      [texte]="texte"
      [altText]="altText"
      [placement]="placement"
      [width]="width"
    ></app-tooltip-desktop>
  </div>
</div>
